/**
 * @file automatically generated from MApp.Endpoints.DatasetContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { IDataset, IValidationResult } from '../models';

export class DatasetContentClient extends MetadataClient {

    public static getDatasets() {
        return MetadataClient.ajax<IDataset[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/datasets`)
        );
    }

    public static getDatasetsByType(datasetType: number) {
        return MetadataClient.ajax<IDataset[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/datasets/${datasetType}`)
        );
    }

    public static getCachedDatasets() {
        return MetadataClient.ajax<IDataset[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/datasets/cached`)
        );
    }

    public static isValidDataset(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/datasets/isvalid?name=${encodeURIComponent(name)}`)
        );
    }
}
